import { useCallback, useState } from 'react';
import { useToast } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { useWorkQueueContext } from '../context/useWorkQueueContext.js';
import { toastNotify } from '../utils/toastNotify.js';

/**
 * Shared general-action state for cards and detail: Ask / Escalate modal targets
 * plus Skip. Skip removes the event from the list and posts a toast noting it
 * will resurface later (delivery-call behavior); the modals are rendered by
 * <EventActionModals /> using the returned state.
 */
export function useEventActions() {
  const { t } = useTranslation('work-queues-app');
  const toast = useToast();
  const { skipEvent } = useWorkQueueContext();
  const [askTarget, setAskTarget] = useState(null);
  const [escalateTarget, setEscalateTarget] = useState(null);

  const openAsk = useCallback((event) => setAskTarget(event), []);
  const closeAsk = useCallback(() => setAskTarget(null), []);
  const openEscalate = useCallback((event) => setEscalateTarget(event), []);
  const closeEscalate = useCallback(() => setEscalateTarget(null), []);

  const skip = useCallback(
    (id) => {
      skipEvent(id);
      toastNotify(toast, { title: t('skip.title'), message: t('skip.message') });
    },
    [skipEvent, toast, t],
  );

  return { askTarget, escalateTarget, openAsk, closeAsk, openEscalate, closeEscalate, skip };
}
